import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'input-debounce',
  templateUrl: './input-debounce.component.html',
  styleUrls: ['./input-debounce.component.scss'],
})
export class InputDebounceComponent {
  @Output() searchStringChange = new EventEmitter<string>();
  @Input() placeholder = 'Search...';
  @Input() debounceTime = 300;
  @Input() fontSize = '16px';
  @Input() width = '350px';
  @Input() active = false;

  private _searchString = '';
  private debounceTimer: NodeJS.Timer;

  get searchString(): string {
    return this._searchString;
  }

  set searchString(value: string) {
    this._searchString = value;

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      this.searchStringChange.emit(this._searchString);
    }, this.debounceTime);
  }

  handleClearSearch(): void {
    this._searchString = '';
    this.searchStringChange.emit(this._searchString);
  }
}
